export default __webpack_public_path__ + "static/media/pic-of-me.05c7e502.jpg";